
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { useState } from 'react';
import { Pagination } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';
export const PaginationControl = ({
  component: Component
}) => {
  const [value, setValue] = useState(1);
  return <div>
      {React.cloneElement(Component, {
      value,
      onChange: v => setValue(v)
    })}
    </div>;
};

const layoutProps = {
  PaginationControl
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Pagination`}</h1>
<p>{`Usage`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Badge } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>

<Playground __position={0} __code={`<PaginationControl component={
  <Pagination
    onChange={x=>x}
    pages={10}
    value={1} />
} />`} component={Pagination} mdxType="Playground">
  <PaginationControl component={<Pagination onChange={x => x} pages={10} value={1} mdxType="Pagination" />} mdxType="PaginationControl" />
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;